import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/AppContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Heritage from "@/pages/Heritage";
import Sadgurus from "@/pages/Sadgurus";
import Trust from "@/pages/Trust";
import BhaktNiwas from "@/pages/BhaktNiwas";
import Darshan from "@/pages/Darshan";
import Festivals from "@/pages/Festivals";
import Events from "@/pages/Events";
import Reach from "@/pages/Reach";
import Gallery from "@/pages/Gallery";
import News from "@/pages/News";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/audumbar" element={<Heritage />} />
              <Route path="/sadguru" element={<Sadgurus />} />
              <Route path="/math" element={<Trust />} />
              <Route path="/bhakt-niwas" element={<BhaktNiwas />} />
              <Route path="/darshan" element={<Darshan />} />
              <Route path="/festivals" element={<Festivals />} />
              <Route path="/events" element={<Events />} />
              <Route path="/reach" element={<Reach />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/news" element={<News />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
